import React from 'react';

// Components
import { Animation, FormElements } from '@/Components';

// Constants
import { CLASS_NAME as BASE_CLASS_NAME } from '@/Components/Form/Checkbox/constants';

// Spec
import * as Spec from './Spec';

const CLASS_NAME = `${BASE_CLASS_NAME}--group`;

const Group = React.forwardRef<HTMLFieldSetElement, Spec.Props>(
  ({ autoFlow = 'row', legend, name, options, ...rest }, ref) => {
    return (
      <Animation in={!!options?.length}>
        <FormElements.Fieldset
          {...rest}
          autoFlow={autoFlow}
          className={CLASS_NAME}
          ref={ref}
        >
          <FormElements.Legend>{legend}</FormElements.Legend>
          {options?.map((option) => {
            return (
              <FormElements.Checkbox
                {...option}
                key={String(option.label)}
                name={`${name}[]`}
              />
            );
          })}
        </FormElements.Fieldset>
      </Animation>
    );
  }
);

type GroupProps = Spec.Props;

Group.displayName = 'Checkbox.Group';

export { type GroupProps };
export default Group;
